import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
import { Employee, FormConfig } from "@/types";
import InnForm from "@/components/ds/form/Form.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeMail',
  props: {
    employee: {
        type: Object as PropType<Employee>,
        required: true,
    },
},
  setup(__props) {



const config: FormConfig = {
    sections: [
        {
            items: [
                {
                    type: "html",
                    key: "mail_footer",
                    label: "Email footer",
                },
            ],
        },
    ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnForm, {
    config: config,
    value: __props.employee
  }, null, 8, ["value"]))
}
}

})